import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebase/firebase";

export default function InOutButton() {
  const [userState, setuserState] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    onAuthStateChanged(auth, user => {
      if (user) {
        setuserState(true)
      }
      else {
        setuserState(false)
      }
    })
  });

  async function logout() {
    await signOut(auth).then(() => {
      navigate("/home")
    })
  }

  let button;
  if (userState) {
    button = <button className="dropdown-item dropdown-item-small" onClick={logout}>Abmelden</button>;
  }
  else {
    button = <Link className="dropdown-item dropdown-item-small" to="/login">Anmelden</Link>;
  }

  return (button)
}